<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Họ và tên' | translate}}<span class="cred">(*)</span></label>
      <div class="col-9">
        <input type="text"  #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.FullName">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3">{{'Số điện thoại' | translate}}<span class="cred">(*)</span></label>
      <div class="col-9">
        <input type="text" tabIndex="2" class="form-control" placeholder="Số điện thoại dùng làm tên đăng nhập" [(ngModel)]="doituongSelect.UserName">
      </div>
    </div>



    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Mật khẩu' | translate}}<span class="cred">(*)</span></label>
      <div class="col-9">
        <input type="password" tabIndex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.PassWord">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Nhắc lại mật khẩu' | translate}}<span class="cred">(*)</span></label>
      <div class="col-9">
        <input type="password" tabIndex="4" class="form-control" placeholder="" [(ngModel)]="doituongSelect.RePassWord">
      </div>
    </div>

    <!--<div class="row form-group">
      <label class="control-label col-3 ng-binding">Tên đơn vị<span class="cred">(*)</span></label>
      <div class="col-9">
        <textarea name="description" tabIndex="5" [(ngModel)]="doituongSelect.TenCongTy" placeholder="Tên đơn vị" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="2"> </textarea>
      </div>
    </div>-->

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Địa chỉ' | translate}}<span class="cred">(*)</span></label>
      <div class="col-9">
        <textarea name="description" tabIndex="6" [(ngModel)]="doituongSelect.DiaChi" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="2"> </textarea>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Email' | translate}}<span class="cred">(*)</span></label>
      <div class="col-9">
        <textarea name="description" tabIndex="7" [(ngModel)]="doituongSelect.Email" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="1"> </textarea>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Ghi chú' | translate}}</label>
      <div class="col-9">
        <textarea name="description" tabIndex="8" [(ngModel)]="doituongSelect.GhiChu" placeholder="Ghi chú" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="3"> </textarea>
      </div>
    </div>


  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div class="checkbox c-checkbox">
    <!--<label>
            <input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.Trang_Thai" />
        <span class="fa fa-check"></span>{{hoatdong}}</label>-->
  </div>
  <div>
    <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Đăng ký' | translate}}</button>
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
  </div>

</div>


